import {useQuery} from '@tanstack/react-query';

import {GetListOutput, GetListParams, QueryOptionsForList} from '@shared/api';
import {getPoolStakes} from '../api';
import {QUERY__POOL_STAKES} from '../queryKeys';
import {Stake} from '../types';

export const useGetPoolStakes = <SelectedData = GetListOutput<Stake>>(
  params: GetListParams & {groupId: string},
  options?: QueryOptionsForList<Stake, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__POOL_STAKES, params],
    queryFn: () => getPoolStakes(params),
    ...options,
  });
